// BOORO: the people who asked for access on the website, and letting them in.
import { oc } from "@orpc/contract";
import * as z from "zod";
import { Id } from "./ids.js";

/** What a visitor sends from the website. */
export const WaitlistSignupSchema = z.object({
  email: z.string().trim().toLowerCase().email().max(254),
  source: z.string().trim().max(40).default("website"),
});

export const WaitlistEntrySchema = z.object({
  id: Id,
  email: z.string(),
  source: z.string(),
  createdAt: z.string(),
  invitedAt: z.string().nullable(),
});
export type WaitlistEntry = z.infer<typeof WaitlistEntrySchema>;

export const booroWaitlistContract = {
  list: oc.output(z.array(WaitlistEntrySchema)),
  /** Puts the address on the signup allowlist. */
  invite: oc.input(z.object({ id: Id })).output(WaitlistEntrySchema),
};
